document.addEventListener('DOMContentLoaded', function () {
  // ===================All Variabls ====================
  
 let currentPage = 1;
  let starRating = 5;
  let NormalApi = false;
  let selectedStarCount = 0;
  let Count = 20;
  let DataCount = 0;
  let TotalReviewsCounts = 0;
  let AccessToken = "";
  let reviewImages = [];
  const reviewsContainer = document.getElementById('reviews_content_wraper');
  const reviewsButtonContainer = document.getElementById('reviews_Button_wraper');
  const review_header = document.getElementById('review_header');
  const reviewsWrapper = document.getElementById('reviews_wraper');
const productSku = reviewsWrapper.getAttribute('data-sku');
const productImage = reviewsWrapper.getAttribute('data-image');
const productName = reviewsWrapper.getAttribute('data-url');
const orignalName = reviewsWrapper.getAttribute('data-title');
  const reviewsPerPage = 5;
  const apiKey = 'lzK0Gfv6P1x2Q94fFC5IS5JJ8uIdFkoe';
  const businessUnitId = '6560b2beb85b0355b48fb204';

    // ==================================Set up translations ==============
const t = window.themeStrings?.trustpilot_reviews || {};

  // ==================================Call all function after loading ==============
setTimeout(function(){
  // =========================================Header Api Code =======================
 function fetchData(apiUrl){return fetch(apiUrl,{headers:{'apikey':apiKey,'Content-Type':'application/json'}}).then(response=>response.ok?(document.querySelector('.reviews_loader').classList.add('hidden'),response.json()):Promise.reject('Network response was not ok.')).catch(error=>console.error('Error fetching data:',error));}
  // ===========================================Imported reviews Header Api ===========================
  function fetchTotalReviewsCount() {
    var apiUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/imported-reviews-summaries?productUrl=${productName}&sku=${productSku}`;   
    return fetch(apiUrl, {
      headers: {
        'apikey': apiKey,
        'Content-Type': 'application/json',
      },
    })
        .then(response => response.json())
      .then(data => {        
        const Data = data;
        const totalReviewsCount = data ? data.numberOfReviews : 0;
        DataCount = totalReviewsCount.total
        if(totalReviewsCount.total > 0 ){
           NormalApi = false
          TotalReviewsCounts = totalReviewsCount.total
          
        return totalReviewsCount;
        // console.log(TotalReviewsCounts)
      }else{
     var totalCounts =  fetchTotalReviewsCountNormal();
          return totalCounts
      }
      })
        .catch(error => {
            console.error('Error fetching total reviews count:', error);
            return 0;
        });
}
  // ===========================================Normal reviews Header Api ===========================

function fetchTotalReviewsCountNormal() {
   if(productSku === 'null'){
    var apiUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}?productUrl=${productName}`;
    }else{
    var apiUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}?sku=${productSku}`;
   }
    return fetch(apiUrl, {
      headers: {
        'apikey': apiKey,
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        const Data = data;
        const totalReviewsCount = data ? data.numberOfReviews : 0;
        DataCount = totalReviewsCount.total
        TotalReviewsCounts = totalReviewsCount.total
        // console.log(TotalReviewsCounts)
         NormalApi = true
        return totalReviewsCount;
      })
        .catch(error => {
            console.error('Error fetching total reviews count:', error);
            return 0;
        });
}
// =======================================Reviews Body Api Imported======================
  function fetchReviews(page, perPage) {
    // console.log(starRating)
    var apiUrl = starRating
      ? `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/imported-reviews?sku=${productSku}&stars=${starRating}&page=${page}&perPage=${perPage}`
      : `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/imported-reviews?sku=${productSku}&page=${page}&perPage=${perPage}`;
      // console.log("apiUrl" , apiUrl)
    NormalApi = false
    return fetchData(apiUrl).catch(error => {
      console.error('Error fetching reviews:', error);
    });
  }
// =======================================Reviews Body Api Normal======================

  function fetchReviewsnormal(page, perPage) {
    // console.log(starRating)
     var apiUrl = starRating
      ? `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?sku=${productSku}&stars=${starRating}&page=${page}&perPage=${perPage}`
      : `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?sku=${productSku}&page=${page}&perPage=${perPage}`;
    
        // console.log("apiUrl2" , apiUrl)
   NormalApi = true
    return fetchData(apiUrl).catch(error => {
      console.error('Error fetching reviews:', error);
    });
  }
// =======================Display Reviews Function For Reviews Body ===============================
  function displayReviews(reviews) {
    if (!reviewsContainer) {
      console.error('Reviews container not found.');
      return false;
    }
    reviews.forEach(review => {
      const reviewElement = createReviewElement(review);
      reviewsContainer.appendChild(reviewElement);
    });
    return reviews.length > 0;
  }

// =========================================Create Reviews Element ===================
  function createReviewElement(review) {
  const reviewElement = document.createElement('div');
  const stars = createStars(review.stars);

  const verifiedStatus = `${t.verified_buyer || 'Verified Buyer'} <span>&#10003;</span>`;
  const reviewingText = t.reviewing || 'Reviewing';

  const Name = review.consumer.name || review.consumer.displayName;

  reviewElement.innerHTML = `
    <div class="review-widget">
      <div class="left_review_wraper">
        <div class="name bold">${Name}</div>
        <span class="review_status verified bold">${verifiedStatus}</span>
        <div class="product_review_prdoct">
          <a href="${productName}">
            <img src="${productImage}">
          </a>
          <div class="product_data_review">
            <b class="bold">${reviewingText}</b>
            <span>${orignalName}</span>
          </div>
        </div>
      </div>
      <div class="review_content_inner">
        <div class="inner_c_stars">
          <div class="stars"><img src="${stars}"></div>
          <span class="created_at">${timeAgo(review.createdAt)}</span>
        </div>
        <div class="title hidden">${review.type}</div>
        <div class="description">${review.content}</div>
      </div>
    </div>
    <hr>
  `;

  return reviewElement;
}
// ===============================Create Stars Count Svgs= =======================
  function createStars(count) {
    let starsImage = '';
    if(count === 0){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_0star_grey-RGB.png?v=1704287537'}
    else if(count <= 1){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_1star-RGB-256x48.png?v=1704287658'}
    else if(count <= 1.7){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_1halfstar-RGB-128x24.png?v=1704288326'}
    else if(count <= 2){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_2star-RGB-128x24.png?v=1704287537'}
    else if(count <= 2.7){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_2halfstar-RGB-128x24.png?v=1704288327'}
    else if(count <= 3){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_3star-RGB-128x24.png?v=1704287537'}
    else if(count <= 3.7){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_3halfstar-RGB-128x24.png?v=1704288326'}
    else if(count <= 4){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_4star-RGB-128x24.png?v=1704287537'}
    else if(count <= 4.7){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/4.5_star-_brand_color_2.png?v=1774434127'}
    else if(count <= 5){starsImage = 'https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_ratings_5starbrand.svg?v=1774435357'}
    return starsImage;
  }
// =======================Reviews Time Function ========================================
  function timeAgo(date) {
  const now = new Date();
  const reviewDate = new Date(date);
  const timeDifference = now - reviewDate;

  const years = Math.floor(timeDifference / (365 * 24 * 60 * 60 * 1000));
  const months = Math.floor(timeDifference / (30 * 24 * 60 * 60 * 1000));
  const weeks = Math.floor(timeDifference / (7 * 24 * 60 * 60 * 1000));
  const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));

  if (years > 0) {
    return years === 1
      ? (t.time?.one_year_ago || '1 year ago')
      : `${years} ${t.time?.years_ago || 'years ago'}`;
  } else if (months > 0) {
    return months === 1
      ? (t.time?.one_month_ago || '1 month ago')
      : `${months} ${t.time?.months_ago || 'months ago'}`;
  } else if (weeks > 0) {
    return weeks === 1
      ? (t.time?.one_week_ago || '1 week ago')
      : `${weeks} ${t.time?.weeks_ago || 'weeks ago'}`;
  } else if (days > 0) {
    return days === 1
      ? (t.time?.yesterday || 'Yesterday')
      : `${days} ${t.time?.days_ago || 'days ago'}`;
  } else {
    return t.time?.today || 'Today';
  }
}
// +=================================Create LoadMore button ========================
  function initLoadMoreButton() {
    const loadMoreBtn = document.createElement('button');
    loadMoreBtn.id = 'load_more_button';
    loadMoreBtn.classList.add('button' , 'button--lg');
    loadMoreBtn.textContent = t.load_more || 'Load More';
    reviewsButtonContainer.appendChild(loadMoreBtn);
    const loadMoreButton = document.getElementById('load_more_button');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        fetchAndDisplayReviews();
      });
    }
  }
// =====================================Fetch and Display Reviews ====================
  function fetchAndDisplayReviews() {
    if(NormalApi === false){
    fetchReviews(currentPage, reviewsPerPage)
      .then(data => {
        const reviewData = data;
        const totalReviewsCount = reviewData.productReviews.length;
       Count = reviewData.productReviews.length
          const loadMoreButton = document.getElementById('load_more_button');
          const hasMoreReviews = displayReviews(data.productReviews);
          //console.log('data' , data)
          if (Count === 5) {
            loadMoreButton.classList.remove('hidden');
             loadMoreButton.disabled = false;
                  loadMoreButton.textContent = t.load_more || 'Load More';
            currentPage++;
          } else {
            if (loadMoreButton) {
              loadMoreButton.disabled = true;
              loadMoreButton.textContent = 'No More Reviews';
              loadMoreButton.classList.add('hidden');
            }
          }
      })
    }
        else {
          fetchReviewsnormal(currentPage, reviewsPerPage)
            .then(data => {
              
              Count = data.productReviews.length
              
              const hasMoreReviews = displayReviews(data.productReviews);
              const loadMoreButton = document.getElementById('load_more_button');
               // console.log('data1' , data)
              if (Count === 5) {
                currentPage++;
                loadMoreButton.classList.remove('hidden');
                loadMoreButton.disabled = false;
                  loadMoreButton.textContent = t.load_more || 'Load More';
              } else {
                if (loadMoreButton) {
                  loadMoreButton.disabled = true;
                  loadMoreButton.textContent = 'No More Reviews';
                  loadMoreButton.classList.add('hidden');
                }
              }
            });
        }
  }
// ====================================Display Header Data ============================
  // Initial load
  fetchTotalReviewsCount().then(totalReviewsCount => {
      var FiveStars = totalReviewsCount.fiveStars;
    var FiveStarsVolum = (totalReviewsCount.fiveStars / totalReviewsCount.total) * 100;
    if (totalReviewsCount.fiveStars >= 1000) { var FiveStarsRounded = (totalReviewsCount.fiveStars) / 1000 + 'k' } else { var FiveStarsRounded = totalReviewsCount.fiveStars }
    var FourStars = totalReviewsCount.fourStars;
    var FourStarsVolum = (totalReviewsCount.fourStars / totalReviewsCount.total) * 100;
    if (totalReviewsCount.fourStars >= 1000) { var FourStarsRounded = (totalReviewsCount.fourStars) / 1000 + 'k' } else { var FourStarsRounded = totalReviewsCount.fourStars }
    var ThreeStars = totalReviewsCount.threeStars
    var ThreeStarsVolum = (totalReviewsCount.threeStars / totalReviewsCount.total) * 100;
    if (totalReviewsCount.threeStars >= 1000) { var ThreeStarsRounded = (totalReviewsCount.threeStars) / 1000 + 'k' } else { var ThreeStarsRounded = totalReviewsCount.threeStars }
    var TwoStars = totalReviewsCount.twoStars
    var TwoStarsVolum = (totalReviewsCount.twoStars / totalReviewsCount.total) * 100;
    if (totalReviewsCount.twoStars >= 1000) { var TwoStarsRounded = (totalReviewsCount.twoStars) / 1000 + 'k' } else { var TwoStarsRounded = totalReviewsCount.twoStars }
    var OneStars = totalReviewsCount.oneStar
    var OneStarsVolum = (totalReviewsCount.oneStar / totalReviewsCount.total) * 100;
    if (totalReviewsCount.oneStar >= 1000) { var OneStarsRounded = (totalReviewsCount.oneStar) / 1000 + 'k' } else { var OneStarsRounded = totalReviewsCount.oneStar }
    var TotalReviews = totalReviewsCount.total
    var allReviesCoutPersent =(((((FiveStars * 5) + (FourStars * 4) + (ThreeStars * 3) + (OneStars * 1)) / (TotalReviews * 5)) * 5) / 0.05) * 0.05;
    // console.log(allReviesCoutPersent.toFixed(1));
    const stars = createStars(allReviesCoutPersent.toFixed(1))
    var StarSvg = `<img src="https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Single_Brand_star_1.png?v=1774434127" style="max-width:30px; width:25px">`;
    var dataHeader = `<div class="header_widget_left">
      <div class="reviews_grad">
        <span>${allReviesCoutPersent.toFixed(1)}</span>
        <span> <img src="${stars}" width="100%" style="max-width:200px"></span>
      </div>
      <h4 class="review_Totals">${(t.based_on || 'Based on ')}${TotalReviews}${(t.reviews || ' reviews')}</h4>
      <div class="reviews_All_counts">
        <div class="fivestars_count Counts_wrap">
          <span>5</span> ${StarSvg} <div class="wigit_volum_wraper" data-count="5">  <div class="wigit_volum" style="width:${FiveStarsVolum}%;">&nbsp</div> </div> <span> ${FiveStarsRounded}</span>
        </div>
        <div class="fourStars_count Counts_wrap">
          <span>4</span> ${StarSvg} <div class="wigit_volum_wraper"  data-count="4">  <div class="wigit_volum" style="width:${FourStarsVolum}%;">&nbsp</div> </div> <span> ${FourStarsRounded}</span>
        </div>
        <div class="threestars_count Counts_wrap">
          <span>3</span>  ${StarSvg} <div class="wigit_volum_wraper"  data-count="3">  <div class="wigit_volum" style="width:${ThreeStarsVolum}%;">&nbsp</div> </div>  <span>  ${ThreeStarsRounded}</span>
        </div>
        <div class="twostars_count Counts_wrap">
          <span>2</span>  ${StarSvg} <div class="wigit_volum_wraper"  data-count="2">  <div class="wigit_volum" style="width:${TwoStarsVolum}%;">&nbsp</div> </div>  <span> ${TwoStarsRounded} </span>
        </div>
        <div class="onestar_count Counts_wrap">
          <span>1</span>  ${StarSvg} <div class="wigit_volum_wraper"  data-count="1">  <div class="wigit_volum" style="width:${OneStarsVolum}%;">&nbsp</div> </div> <span>  ${OneStarsRounded}</span>
        </div>
      </div>
    </div>
    <div class="reviews_right_photo_gallery">
    <div class="trust_image">
    <a href="https://nl.trustpilot.com/review/barecookware.com/ ">
  <img src="https://cdn.shopify.com/s/files/1/0779/2895/6237/files/Trustpilot_Logo_Brand_Color_2.png?v=1774434127" width="100%">
    </a>
  </div>
    <div class="reviews_gallery">
    </div>
    </div>
    `;
    // ================================================================================Append the Data and Call functions Onload ===============
     review_header.innerHTML = dataHeader;
    fetchAndDisplayReviews();
    initLoadMoreButton();
    // =======================================Hide  Balnk reviews div ======================
    var Wraper = document.getElementById('reviews_wraper');
    // console.log(DataCount)
    if(DataCount === 0){
      Wraper.classList.add('hidden')
    }else{
      Wraper.classList.remove('hidden')
    }
    // ========================================================Reviews Filter Function=============================
    const WidgetFilter = document.querySelectorAll('.wigit_volum_wraper');
    WidgetFilter.forEach((widget) => {
      widget.addEventListener('click', function () {
        WidgetFilter.forEach(filter => filter.classList.remove('selected') );
        this.classList.add('selected') 
            reviewsContainer.innerHTML = ''
        currentPage = 1
        starRating = widget.getAttribute('data-count');
        this.closest('.reviews_wraper').querySelector('.reviews_loader').classList.remove('hidden');
        fetchAndDisplayReviews();
      });
    });
  });
// ===============================================Reviews Images Function on Load =======================
function fetchReviewImages(page) {
  var apiUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/imported-reviews?sku=${productSku}&page=${page}&perPage=100`;
  // console.log("apiUrl", apiUrl);
  return fetchData(apiUrl).catch(error => {
    console.error('Error fetching reviews:', error);
  });
}

function fetchReviewImagesnormal(page) {
  var apiUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?sku=${productSku}&page=${page}&perPage=100`;
  // console.log("apiUrl", apiUrl);
  return fetchData(apiUrl).catch(error => {
    console.error('Error fetching reviews:', error);
  });
}
// ========================================Create Image element and append =========================
function reviewImage(review) {
  var attachments = review.attachments;
  var processedFiles = attachments && attachments.length !== 0 ? attachments[0].processedFiles : null;

  if (processedFiles && processedFiles.length !== 0) {
    var firstProcessedFile = processedFiles[0];
   
    if (processedFiles.length > 1) {
      var secondProcessedFile = processedFiles[1];
      var thirdProcessedFile = processedFiles[2];
    }else{
      secondProcessedFile = firstProcessedFile;
      thirdProcessedFile = firstProcessedFile;
    }
    
  

    if (!reviewImages.includes(thirdProcessedFile.url)) {
      var Gallery = document.querySelector('.reviews_gallery');
      const reviewImageElemet = document.createElement('div');
      const reviewImagePopupElemet = document.createElement('div');
      reviewImageElemet.classList.add('gallery_image');
      reviewImagePopupElemet.classList.add('image_light_box_wraper', 'hidden');
      var Image = `<img src="${secondProcessedFile.url}" width="100%" onClick='openPopup("${thirdProcessedFile.url}")'>`;
      var imagePopup = `<div class="light-box-overlay" onClick='closePopup("${thirdProcessedFile.url}")'>&nbsp;</div> <div class="reviw_image"><img class="popu-image" src="${thirdProcessedFile.url}" width="100%"></div>`;
      reviewImageElemet.innerHTML = Image;
      reviewImagePopupElemet.innerHTML = imagePopup;
      Gallery.appendChild(reviewImageElemet);
      Gallery.appendChild(reviewImagePopupElemet);
      reviewImages.push(thirdProcessedFile.url);
    }
  }
}
// =======================diplay image function==========
function displayReviewImages(reviews) {
  if (!reviewsContainer) {
    console.error('Reviews container not found.');
    return false;
  }
  reviews.forEach(review => {
    reviewImage(review);
  });
  return reviews.length > 0;
}
let currentPageImages = 1;
// =====================================Fetch and Display actual api data=====================
function fetchAndDisplayImages() {
  // console.log('NormalApi', NormalApi)
  if (NormalApi === false) {
    fetchReviewImages(currentPageImages)
      .then(data => {
        // console.log('dataImage', data);
        const hasMoreReviews = displayReviewImages(data.productReviews);
        if (hasMoreReviews) {
          currentPageImages++;
          fetchAndDisplayImages(); // Fetch next page recursively
        }
      });
  } else {
    fetchReviewImagesnormal(currentPageImages)
      .then(data => {
        // console.log('dataImage1', data);
        const hasMoreReviews = displayReviewImages(data.productReviews);
        if (hasMoreReviews) {
          currentPageImages++;
          fetchAndDisplayImages();
        }
      });
  }
}
// ============================repeat Fetching data untill display all the images===================
setTimeout(function () {
  let countPages = Math.ceil(TotalReviewsCounts / 100);
  // console.log('TotalReviewsCount', TotalReviewsCounts);
  for (var i = 0; i < countPages; i++) {
    fetchAndDisplayImages();
  }
}, 2000);


 
}, 2000);
});



